import script from "./MasterclassFormBase.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterclassFormBase.vue?vue&type=script&setup=true&lang=js"

import "./MasterclassFormBase.vue?vue&type=style&index=0&id=6b552463&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b552463"]])

export default __exports__